/**
 * Rocket Launcher RL-2 — register the root-scope service worker.
 * Only on https or localhost (secure contexts). No-op elsewhere.
 */

export function registerRocketLauncherSw () {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  const { protocol, hostname } = window.location
  const isSecure =
    protocol === 'https:' ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1'
  if (!isSecure) return

  // Defer so first paint / Vue mount aren't blocked.
  const run = () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => {
        // Install CTA (RL-4) can still fall back to iOS Shortcut / instructions.
        console.info('[Rocket Launcher] service worker register skipped:', err)
      })
  }

  if (document.readyState === 'complete') {
    run()
  } else {
    window.addEventListener('load', run, { once: true })
  }
}
